
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';



export interface MedicalHistoryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface MedicalHistoryMst {
    id?: any;
    tenantId: any;
    branchId: any;  
    name:string;
    isActive?:Boolean;
    mappingAttribute?:string;
    typeId?: number;
    typeName?: string;


    parameters?: MedicalHistoryParameter[];
    links?: any;
}

export abstract class MedicalHistoryData {     

    abstract list(url: string): Observable<MedicalHistoryMst[]>; 
    abstract create(url: string, data: MedicalHistoryMst): Observable<MedicalHistoryMst[]>;
    abstract update(url: string, data: MedicalHistoryMst): Observable<MedicalHistoryMst>;
    abstract delete(url: string): Observable<any>; 
}
